import { Action } from '@ngrx/store';

export enum ProductActionTypes {
  GET_PRODUCTS = '[Products] GET',
  GET_PRODUCTS_SUCCESS = '[Products] GET Success',
  GET_PRODUCTS_FAILURE = '[Products] GET Failure',

  SET_PRODUCT = '[Product] SET Product',
  SET_PRODUCT_SUCCESS = '[Product] SET Product Success',
  SET_PRODUCT_FAILURE = '[Product] SET Product Failure',

  EDIT_PRODUCT = '[Product] EDIT Product',
  CREATE_PRODUCT = '[Product] CREATE Product',
  UPDATE_PRODUCT = '[Product] UPDATE Product',

  GET_PRODUCT_MEDIA = '[Products] GET Media',
  GET_PRODUCT_MEDIA_SUCCESS = '[Products] GET Media Success',
  GET_PRODUCT_MEDIA_FAILURE = '[Products] GET Media Failure',

  GET_ALL_PRODUCTS_MEDIA = '[Products] GET All Products Media',
  GET_ALL_PRODUCTS_MEDIA_SUCCESS = '[Products] GET All Products Media Success',
  GET_ALL_PRODUCTS_MEDIA_FAILURE = '[Products] GET All Products Media Failure',

}

// PRODUCTS
export class GetProducts implements Action {
  readonly type = ProductActionTypes.GET_PRODUCTS;
  constructor(public payload: any) {}
}
export class GetProductsSuccess implements Action {
  readonly type = ProductActionTypes.GET_PRODUCTS_SUCCESS;
  constructor(public payload: any) {}
}
export class GetProductsFailure implements Action {
  readonly type = ProductActionTypes.GET_PRODUCTS_FAILURE;
  constructor(public payload: any) {}
}

// PRODUCT MEDIA
export class GetProductMedia implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_MEDIA;
  constructor(public payload: any) {}
}
export class GetProductMediaSuccess implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_MEDIA_SUCCESS;
  constructor(public payload: any) {}
}
export class GetProductMediaFailure implements Action {
  readonly type = ProductActionTypes.GET_PRODUCT_MEDIA_FAILURE;
  constructor(public payload: any) {}
}

// PRODUCTS ALL MEDIA
export class GetAllProductsMedia implements Action {
  readonly type = ProductActionTypes.GET_ALL_PRODUCTS_MEDIA;
  constructor(public payload: any) {}
}
export class GetAllProductsMediaSuccess implements Action {
  readonly type = ProductActionTypes.GET_ALL_PRODUCTS_MEDIA_SUCCESS;
  constructor(public payload: any) {}
}
export class GetAllProductsMediaFailure implements Action {
  readonly type = ProductActionTypes.GET_ALL_PRODUCTS_MEDIA_FAILURE;
  constructor(public payload: any) {}
}

// PRODUCT
export class EditProduct implements Action {
  readonly type = ProductActionTypes.EDIT_PRODUCT;
  constructor(public payload: any) {}
}
export class CreateProduct implements Action {
  readonly type = ProductActionTypes.CREATE_PRODUCT;
  constructor(public payload: any) {}
}
export class SetProduct implements Action {
  readonly type = ProductActionTypes.SET_PRODUCT;
  constructor(public payload: any) {}
}
export class SetProductSuccess implements Action {
  readonly type = ProductActionTypes.SET_PRODUCT_SUCCESS;
  constructor(public payload: any) {}
}
export class SetProductFailure implements Action {
  readonly type = ProductActionTypes.SET_PRODUCT_FAILURE;
  constructor(public payload: any) {}
}


export type All =
  | GetProducts
  | GetProductsSuccess
  | GetProductsFailure
  | EditProduct
  | CreateProduct
  | SetProduct
  | SetProductSuccess
  | SetProductFailure
  | GetProductMedia
  | GetProductMediaSuccess
  | GetProductMediaFailure
  | GetAllProductsMedia
  | GetAllProductsMediaSuccess
  | GetAllProductsMediaFailure



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/actions/product.actions.ts